// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","737":"fb7d5399","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"9a72ac01e08df4fe010a","737":"67825f51a4857e668bd6","883":"6db2d6a21195e7724a95","954":"7e574248d1fdfb95581f"}[chunkId] + ".js";
};